import React, { useRef } from "react";
import { rock_on_icon } from "../../Assets";
import { Link } from "react-router-dom";
import Navbar from "../../Components/Navbar";
import emailjs from '@emailjs/browser'
import aboutDBdata from "../../DB/About.json";
import { FaXTwitter } from "react-icons/fa6";
import { FaLinkedin , FaInstagram } from "react-icons/fa";



const Contact = () => {
  const formRef = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.init('1I1HY_-mvdLmz4fFh')

    const formData = new FormData(e.target);
    const name = formData.get('user_name');
    const email = formData.get('user_email');
    const message = formData.get('message');
    const mobile = formData.get('mobile');
    const subject = formData.get('subject');

    // console.log(formRef.current)

    emailjs.send("service_4pvtqjl", "template_hga2oxo", {
      from_name: name,
      to_name: "maheebullahkhan2000@gmail.com ",
      mobile: mobile,
      subject: subject,
      message: message,
      reply_to: email
    });
  };


  return (
    <>
      <div className="app-main-wrapper">
        <Navbar />
        <div className="contact-main-wrapper-cover">
          <div className="container">
            <div className="contact-inner-cover-wrapper">
              <div className="contact-top-box-cover">
                <div className="row d-flex justify-content-between align-items-center">
                  <div className="col-lg-5">
                    <div className="contact-main-heading">
                      <h5 className="contact-heading-title">
                        Ready to connect and make waves together?
                        <span>
                          <img src={rock_on_icon}></img>
                        </span>
                      </h5>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="contact-heading-details">
                      <p>
                        "Embark on a journey with us – your inquiries are the
                        spark to our next big adventure! Ring us for a touch of
                        greatness."
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="contact-form-cover-wrapper">
                <div className="row d-flex justify-content-between">
                  <div className="col-lg-4">
                    <div className="contact-details-box-cover">
                      <div className="contact-heading-small-title">
                        <h5>DON'T BE AFRAID MAN !</h5>
                        <h5>SAY HELLO</h5>
                      </div>
                      <div className="contact-detail-inner-box">
                        <div className="contact-detail-box">
                          <div className="contact-link">
                            <Link href="tel:8080031998">+91 8080031998</Link>
                          </div>
                        </div>
                        <div className="contact-detail-box">
                          <div className="contact-link">
                            <Link href="mailto:maheebullahkhan2000@gmail.com">maheebullahKhan2000@gmail.com</Link>
                          </div>
                        </div>
                      </div>

                      <div className="contact-follow-box">
                        <h5>FOLLOW</h5>

                        <div className="contact-follow-pills-cover mt-3">
                          {aboutDBdata.social_links.map((social, ind) => {
                            return (
                              <span className={`${ind == 0} ? add-extra-margin : social-icon-box`}>
                                <Link to={social?.link} target="__blank">
                                  {ind == 0 ? <FaXTwitter /> : ind == 1 ? <FaLinkedin /> : <FaInstagram />}
                                </Link>
                              </span>
                            )
                          })}
                    
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-7">
                    <div className="contact-form-wrapper">
                      <form ref={formRef} onSubmit={sendEmail}>
                        <div className="row">
                          <div className="col-lg-6 mb-lg-4 mb-3">
                            <div className="contact-input-box">
                              <input type="text" name="user_name" placeholder="Name" required></input>
                            </div>
                          </div>
                          <div className="col-lg-6 mb-lg-4 mb-3">
                            <div className="contact-input-box">
                              <input type="email" name="user_email" placeholder="Email" required></input>
                            </div>
                          </div>
                          <div className="col-lg-6 mb-lg-4 mb-3">
                            <div className="contact-input-box">
                              <input type="text" name="mobile" placeholder="Phone" required></input>
                            </div>
                          </div>
                          <div className="col-lg-6 mb-lg-4 mb-3">
                            <div className="contact-input-box">
                              <input type="text" name="subject" placeholder="Subject" required></input>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="contact-input-box">
                              <textarea name="message" placeholder="Messages"></textarea>
                            </div>
                          </div>
                        </div>
                        <div className="quotes-btn-box-cover">
                          <button type="submit">SEND ME QUOTES</button>
                        </div>
                      </form>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
